import React from 'react'
import { Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import Badge, { badgeClasses } from '@mui/material/Badge'
import ButtonBase from '@mui/material/ButtonBase'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useFeature } from '@cbgms/base/feature-flags'

const useStyles = makeStyles(theme => ({
  button: {
    padding: theme.spacing(1, 2)
  },
  buttonCompact: {
    padding: theme.spacing(1),
    [theme.breakpoints.up('xl')]: {
      padding: theme.spacing(1, 1.5)
    }
  },
  badge: {
    [`& .${badgeClasses.anchorOriginTopRightCircular}:not(.${badgeClasses.invisible})`]: {
      transform: 'scale(0.8) translate(50%, -50%)'
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  }
}))

interface TopBarMenuItemProps {
  badge: number
  startIcon?: React.ReactElement
  children?: React.ReactNode
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  isMenu?: boolean // isMenu will render an expand icon when true
}

export const TopBarMenuItem: React.FC<TopBarMenuItemProps> = props => {
  const classes = useStyles()
  const { badge, startIcon, children, onClick, isMenu, ...rest } = props
  const isTopbarUXChangeEnabled = useFeature('topbar-ux-change-for-timer')

  const icon = startIcon ? React.cloneElement(startIcon, { className: classes.buttonIcon }) : null
  const buttonClassName = isTopbarUXChangeEnabled ? classes.buttonCompact : classes.button

  return (
    <ButtonBase className={buttonClassName} focusRipple onClick={props.onClick} {...rest}>
      <Badge
        className={classes.badge}
        overlap='circular'
        color='error'
        badgeContent={badge}
        data-testid='message-badge'
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {icon}
      </Badge>
      <Typography variant='body2' style={{ paddingLeft: badge > 0 ? '10px' : 0 }}>
        {children}
      </Typography>
      {isMenu && <ExpandMoreIcon />}
    </ButtonBase>
  )
}
